<div class="modal-backdrop" [@modalAnimation]="animationState">
  <div class="completion-modal" [ngClass]="completionType">
    <div class="confetti-container">
      <div class="confetti" *ngFor="let i of completionType === CompletionType.ISSUE ? [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20] : [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]"></div>
    </div>
    
    <div class="completion-icon" [@confettiAnimation]>
      <div class="checkmark-circle" [ngClass]="completionType">
        <div class="checkmark"></div>
      </div>
    </div>
    
    <div class="completion-message" [@confettiAnimation]>
      {{message}}
    </div>
    
    <div class="completion-subtitle" *ngIf="completionType === CompletionType.ISSUE" [@confettiAnimation]>
      🎉 Great achievement! 🎉
    </div>
    
    <div class="task-title" *ngIf="taskTitle" [@confettiAnimation]>
      "{{taskTitle}}"
    </div>
    
    <div class="completion-points" *ngIf="showPoints && pointsValue !== null" [@confettiAnimation]>
      <span class="points-badge" [ngClass]="completionType">+{{pointsValue}}</span>
    </div>
  </div>
</div>
